import { faqItems } from '@/mocks/homepage';

export default function FaqSection() {
  return (
    <section id="faq" className="relative py-16 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于四虎影视大全，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {faqItems.map((item) => (
            <details
              key={item.id}
              open
              className="group bg-background-200/40 border border-background-200/50 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 md:p-6 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.question}</h3>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500/20 flex-shrink-0">
                  <i className="ri-subtract-line text-primary-400"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}